<div class="th-menulevel">
  <div class="ir-btn ir-btn--big th-btn-menulevel" (click)="selectMenu(1)">
    <span>Action Plan Items</span>
  </div>
</div>
